export default __webpack_public_path__ + "static/media/fsAmountIcon.814b832f.svg";